import styled from 'styled-components';
import { TextField } from '@fluentui/react';

export const TextFieldStyle = styled(TextField)`
  .ms-TextField-field {
    color: ${(props) => props.theme.textMainColor};
    background: ${(props) => props.theme.popupInputMainBackground};
    ::placeholder {
      color: ${(props) => props.theme.textMainColor};
    }
  }

  #comments {
    padding: 1rem;
  }

  box-shadow: 0px 0.6px 1.8px rgba(0, 0, 0, 0.11),
    0px 3.2px 7.2px rgba(0, 0, 0, 0.13);
  border-radius: 4px;

  @media (max-width: 710px) {
    width: 100%;
    height: 150px;

    .ms-TextField-fieldGroup,
    #employeeComment,
    .ms-TextField-wrapper {
      height: 100%;
      font-size: 14px;
    }

    #employeeComment {
      padding: 15px 10px;
    }

    @media (max-width: 710px) {
      #employeeComment {
        font-size: 16px;
      }
    }
  }
`;

export const CommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
`;

export const CommentsLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.textMainColor};

  @media (max-width: 710px) {
    font-size: 18px;
  }
`;
